import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import CardBook from "./CardBook";
import "../assets/css/cardBook.css";

const backgroundColor = "rgba(236, 239, 241, 1)";

function Book() {
    const location = useLocation();
    const isLivresPage = location.pathname.includes('/livres');
    const navigate = useNavigate();

    const handleNavigationLivres = () => {
        navigate(`/livres`);
    }
    return (
        <div style={{backgroundColor: backgroundColor}}>
            <div className="container mx-auto px-4 py-4 lg:px-[5%]" id="book">
                <h1 className="text-radar-700 text-center">Parcours proposé</h1>
                {/* Ne pas afficher ce div si l'URL contient "/livres" */}
                {!isLivresPage && (
                    <div className="flex sm:justify-between justify-center mb-4 mt-4">
                        <div></div>
                        <p className="text-radar-800 cursor-pointer" onClick={handleNavigationLivres}>Voir tous</p>
                    </div>
                )}
                <CardBook/>

                {/* Ne pas afficher ce div si l'URL contient "/livres" */}
                {!isLivresPage && (
                    <p className="text-radar-pub text-center italic mt-4">Les enseignants peuvent ici organiser l'accès
                        aux
                        ressources pour les formations ou existe un cours de télédétection</p>
                )}
            </div>
        </div>
    );
}

export default Book;
